import { useMemo } from 'react';
import { PriceTag } from '@music-vine/cadence/ui';
import type { Settings } from '@/types/settings';
export interface CardPlanDescriptionProps {
  children: React.ReactNode;
}
export interface CardPlanPriceProps {
  amount: string;
  currency?: Settings['currency'];
  period: string;
}
export type CardPlanSubtitleProps = string | CardPlanPriceProps;
const CardPlanDescription = ({
  children
}: CardPlanDescriptionProps) => <div className="font-normal font-sans text-gray-700 text-sm leading-5 dark:text-gray-400" data-sentry-component="CardPlanDescription" data-sentry-source-file="CardPlanSubtitle.tsx">
    {children}
  </div>;
const CardPlanPrice = ({
  currency,
  amount,
  period
}: CardPlanPriceProps) => {
  const formattedPeriod = useMemo(() => {
    if (period.endsWith('ly')) {
      return period.slice(0, -2);
    }
    return period;
  }, [period]);
  const isCanadian = currency?.code === 'CAD';
  return <PriceTag className="mt-0.5 ml-auto" currencySymbol={isCanadian ? 'CA$' : currency?.symbol_left ?? ''} frequency={formattedPeriod} price={amount} data-sentry-element="PriceTag" data-sentry-component="CardPlanPrice" data-sentry-source-file="CardPlanSubtitle.tsx" />;
};
export const CardPlanSubtitle = ({
  data
}: {
  data?: CardPlanSubtitleProps;
}) => {
  if (!data) {
    return null;
  }
  if (typeof data === 'string') {
    return <CardPlanDescription>{data}</CardPlanDescription>;
  }
  if (typeof data === 'object' && 'currency' in data && 'amount' in data && 'period' in data) {
    return <CardPlanPrice amount={data.amount} currency={data.currency} period={data.period} />;
  }
  return null;
};